import { render } from "./DeleteRolModal.vue?vue&type=template&id=3f99baa3"
import script from "./DeleteRolModal.vue?vue&type=script&lang=js"
export * from "./DeleteRolModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__